export default __webpack_public_path__ + "static/favicon128-07d96793e0b71148bfd744e8fd4bb0e1.png";